const  path = {
     home: '/'
  } 

  Object.freeze(path);
  
  export default path
  